module.exports = __webpack_public_path__ + "static/media/SDFSA_8-240w.9266c226.webp";